import { usePagination } from "@vega-api/custom/utils/usePagination";
import { useGetCoinvestAuditTrail } from "@vega-api/generated/coinvest-audit/coinvest-audit";
import { type AuditEventResponse } from "@vega-api/generated/types/auditEventResponse";
import { usePaginationState } from "@vega-core/hooks/usePaginationState";
import { isTruthy } from "@vega-core/utils/isTruthy";

type UseAuditDataProps = {
  dealId: string;
  eventNames?: string[];
};

export const useAuditData = ({ dealId, eventNames }: UseAuditDataProps) => {
  const paginationState = usePaginationState();

  const { data: auditResponse, isLoading } = useGetCoinvestAuditTrail(
    {
      dealId,
      // TODO(VD-27533): drop cast once BE loosens eventNames to string params
      eventNames: eventNames as never[],
      page: paginationState.currentPage,
      pageSize: paginationState.currentPageSize,
    },
    {
      query: {
        enabled: isTruthy(dealId),
      },
    },
  );

  const auditEvents: AuditEventResponse[] =
    auditResponse?.data?.filter((event): event is AuditEventResponse =>
      isTruthy(event),
    ) ?? [];
  const meta = auditResponse?.meta ?? null;

  const { paginationElement } = usePagination({
    meta,
    isLoading,
    ...paginationState,
    filterDependencies: [eventNames],
  });

  return {
    auditEvents,
    isLoading,
    paginationElement,
  };
};
